// removed by extract-text-webpack-plugin
module.exports = {"bunker":"_1pPbmJJMe-AQsP29b0a7K1","inPath":"_3_yR-mPZYKTNDpoydIWf97","clogged":"rxbSBC8zzj7xWDNUZO3yT","bunkerType":"_1iaXA9hD9FPBGlprr9UXjS","noria":"_1t8DxmfWxRWPqSnP4wheKu","bunkerInputLine":"_2iNKgIAF_93Lg2Lgac4qqT","wheat":"_2_MIjU7gg9LAetbgOQ3nGf","rape":"_3rmP884Pf8uM96CVi7DUBW","soy":"uCEMLnbwyvHL48aroSYIh","corn":"_2UKZZRZ8dDU4Mekn0YObHm","sunflowermpn":"_1ZY9xz4WOoI8DSw_Mw6OIV","bunkerNumbers":"_3ylugS2IhouHac8Znhbt1h","hide":"HSUIWRIUIymsNrqzfMVUu"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Game/SubComponents/Bunker/index.css
// module id = 184
// module chunks = 0